import React from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";
import DatasourceBaseOauth from "../Datasources/DatasourceBaseOauth.jsx";


const DatasourceTribeCRM = (props) => {

    const AuthUrl = "https://auth.tribecrm.nl/oauth2/auth" +
        "?client_id=bc22a0dc-1c13-46a1-aa31-2cc67bd9a431" +
        "&redirect_uri=https%3A%2F%2Fauth.cloudcti.nl%2Fwebapi%2Foauth2" +
        "&response_type=code" +
        "&scope=read offline"
    const TokenUrl = "https://auth.tribecrm.nl/oauth2/token" 
    const TokenBody = "client_id=bc22a0dc-1c13-46a1-aa31-2cc67bd9a431&client_secret=JdkQFPyC08Mlj7r8XXmpyyYcKRllAy4I3FE3AxGT&redirect_uri=https://auth.cloudcti.nl/webapi/oauth2&grant_type=authorization_code&code=" 
    const TokenBodyType = "application/x-www-form-urlencoded"
    const TokenCodeInBody = true
    
    return (<DatasourceBaseOauth SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} AuthUrl={AuthUrl} TokenUrl={TokenUrl} TokenBody={TokenBody} TokenBodyType={TokenBodyType} TokenCodeInBody={TokenCodeInBody} OnSetReady={props.OnSetReady}/>)

}

DatasourceTribeCRM.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceTribeCRM